(function () {
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var selects = root.querySelectorAll('[data-option-index]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var button = root.querySelector('[data-add-button]');
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variant = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!variant) {
        if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });
})();
